export default {
  methods: {
    formatDate(dateString) {
      /*
       https://stackoverflow.com/questions/6427204/date-parsing-in-javascript-is-different-between-safari-and-chrome
       This handles safari's problems with handling our date time formats
      */
      function dateFromString(str) {
        const a = $.map(str.split(/[^0-9]/), (s) => parseInt(s, 10))
        return new Date(a[0], a[1] - 1 || 0, a[2] || 1, a[3] || 0, a[4] || 0, a[5] || 0, a[6] || 0)
      }

      return new Intl.DateTimeFormat('da-DK').format(dateFromString(dateString))
    },
  },
}
